import { NotificationCRUD} from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function SaveNotification(paramsOrMode, userId, notificationId, onlyUnread) {
    const args =
        paramsOrMode && typeof paramsOrMode === 'object' && !Array.isArray(paramsOrMode)
            ? paramsOrMode
            : {
                mode: paramsOrMode,
                userId,
                notificationId,
                onlyUnread,
            }

    const payload = {
        mode: args?.mode,
        userId: args?.userId || '-1',
        notificationId: args?.notificationId || '-1',
        onlyUnread: args?.onlyUnread || false
    }
    try {
        const res = await getCharts(NotificationCRUD, payload)
        return res.data
    } catch (error) {
        return error
    }
}
